var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 5.33398C17.2802 5.33398 5.3335 17.2807 5.3335 32.0007C5.3335 46.7207 17.2802 58.6673 32.0002 58.6673C46.7202 58.6673 58.6668 46.7207 58.6668 32.0007C58.6668 17.2807 46.7202 5.33398 32.0002 5.33398ZM32.0002 53.334C20.2402 53.334 10.6668 43.7607 10.6668 32.0007C10.6668 20.2407 20.2402 10.6673 32.0002 10.6673C43.7602 10.6673 53.3335 20.2407 53.3335 32.0007C53.3335 43.7607 43.7602 53.334 32.0002 53.334ZM42.3468 22.1073L26.6668 37.7873L21.6535 32.774C20.6135 31.734 18.9335 31.734 17.8935 32.774C16.8535 33.814 16.8535 35.494 17.8935 36.534L24.8002 43.4407C25.8402 44.4807 27.5202 44.4807 28.5602 43.4407L46.1335 25.8673C47.1735 24.8273 47.1735 23.1473 46.1335 22.1073C45.0935 21.0673 43.3868 21.0673 42.3468 22.1073Z",
    fill: "#1BC77B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check-circle-outline.2a4b9765e04abc13e6177435f2442e00.svg";
export { ForwardRef as ReactComponent };